<template>
  <myhead @next="score">{{ $route.query.title || $route.meta.title}}</myhead>
  <div class="pad14">
    <p class="b500 mb25">请对页面打分</p>
    <div class="flex C999 size14 relative between" style="top:5px">
      <p>不满意</p>
      <p>满意</p>
    </div>
    <div class="pad10 relative part03 culture">
      <rates-slider @updateVal = "updateScore"/>
    </div>
    <div class="flex C999 size14 relative between mr8">
      <p>-10</p>
      <p>0</p>
      <p>10</p>
    </div>
    <div class="vh30"></div>
    <van-button round type="primary" @click="score" block v-if="scoreValue!=0">提交</van-button>
    <van-button round type="primary" class="filterGray opacity8" block v-else>提交</van-button>
  </div>
</template>

<script>
import RateSlider from "@/components/RateSlider.vue"
export default {
  components:{'rates-slider':RateSlider},
  data(){
    return {
      scoreValue:0
    }
  },
  watch:{
  },
  methods:{
    updateScore(v){
      this.scoreValue = v;
    },
    score(){
      this.ajax.post("papers/score",{...this.$route.query,score:this.scoreValue}).then(({message})=>{
        this.$store.state.lawKey++
        this.showDialog({message}).then(()=>{
          this.$router.back()
        })
      })
    }
  },
  created(){
    
  }
}
</script>

<style>
</style>
